<template>
    <div>
        <base-header type="instore" class="pb-6 pb-8 pt-5 pt-md-8">
            <!-- Card stats -->
            <div class="row">
                <div class="col-xl-3 col-lg-6">
                    <stats-card title="BXI Store Promos"
                        type="gradient-blue"
                        :sub-title="String(onlineStorePromos)"
                        icon="fas fa-check"
                        class="mb-4 mb-xl-0">
                    </stats-card>
                </div>
                <div class="col-xl-3 col-lg-6">
                    <stats-card title="Shopify Promos"
                        type="gradient-green"
                        :sub-title="String(shopifyPromos)"
                        icon="fas fa-check"
                        class="mb-4 mb-xl-0">
                    </stats-card>

                    <template slot="footer">
                        <br><br>
                    </template>
                </div>
                <div class="col-xl-3 col-lg-6">
                    <stats-card title="Lazada Promos"
                        type="gradient-purple"
                        :sub-title="String(lazadaPromos)"
                        icon="fas fa-check"
                        class="mb-4 mb-xl-0">
                    </stats-card>

                    <template slot="footer">
                        <br><br>
                    </template>
                </div>
                <div class="col-xl-3 col-lg-6">
                    <stats-card title="Shopee Promos"
                        type="gradient-orange"
                        :sub-title="String(shopeePromos)"
                        icon="fas fa-check"
                        class="mb-4 mb-xl-0">
                    </stats-card>

                    <template slot="footer">
                        <br><br>
                    </template>
                </div>
            </div>
        </base-header>

        <div class="container-fluid mt--7">
            <div class="row">
                <div class="col-md-12">
                    <div class="card-body" style="background: #FFFFFF; min-height: 40vh;">
                        <h3>
                          Sales Channel Promotions
                          <base-dropdown class="nav-link pr-0 float-right text-dark" position="right">
                            <div class="media align-items-center" slot="title">
                              <i class="fa fa-ellipsis-v float-right text-dark btn-sm cursor-pointer" style='margin-top: -2px;'></i>
                            </div>
                            <template>
                              <div class="dropdown-item cursor-pointer" @click="fetchPromotions(false)">
                                <i class="fas fa-sync-alt"></i><span>Fetch new promotions</span>
                              </div>
                              <div class="dropdown-item cursor-pointer" @click="fetchPromotions(true)">
                                <i class="fas fa-download"></i><span>Fetch all promotions</span>
                              </div>
                            </template>
                          </base-dropdown>
                          <base-button class="float-right" type="primary" size="sm" @click="showDrawer">+ Add Promo</base-button>
                        </h3>
                        <div class="horizontal-tabs mt-3">
                          <li v-on:click="toggleTab('all')" :class="promoTab === 'all' ? 'active' : ''">All</li>
                          <li v-on:click="toggleTab('allFromBxi')" :class="promoTab === 'allFromBxi' ? 'active' : ''">From BXI</li>
                          <li v-on:click="toggleTab('online_store')" :class="promoTab === 'online_store' ? 'active' : ''">BXI Store</li>
                          <li v-on:click="toggleTab('shopify')" :class="promoTab === 'shopify' ? 'active' : ''">Shopify</li>
                          <li v-on:click="toggleTab('lazada')" :class="promoTab === 'lazada' ? 'active' : ''">Lazada</li>
                          <li v-on:click="toggleTab('shopee')" :class="promoTab === 'shopee' ? 'active' : ''">Shopee</li>
                        </div>
                        <div class="form-row mt-3">
                          <div class="col-2">
                            <div class="dropdown dropdown-form-control">
                              <div class="form-control dropdown-toggle" @click="toggleDropdown('filter')">
                                Filter options
                              </div>
                              <div class="dropdown-menu" v-if="dropdowns.filter">
                                <div class="row py-2 px-3">
                                  <div class="col-6 px-4 border-right">
                                    <small class="text-gray">Search by:</small>
                                    <base-radio name="name" class="mt-2" v-model="filter.searchField" value="name">Name</base-radio>
                                    <base-radio name="code" class="my-2" v-model="filter.searchField" value="code">Code</base-radio>
                                    <small class="text-gray">Sort by:</small>
                                    <base-radio name="updated_at" class="mt-2" v-model="filter.sortBy" value="updated_at">Last updated</base-radio>
                                    <base-radio name="created_at" class="mt-2" v-model="filter.sortBy" value="created_at">Last created</base-radio>
                                  </div>
                                  <div class="col-6 px-4">
                                    <small class="text-gray">Filter promo status:</small>
                                    <base-checkbox class="mt-2" v-model="filter.promoStatus.active">Active</base-checkbox>
                                    <base-checkbox class="my-2" v-model="filter.promoStatus.inactive">Inactive</base-checkbox>
                                    <small class="text-gray">Filter export status:</small>
                                    <base-checkbox class="mt-2" v-model="filter.exportStatus.posted">Posted</base-checkbox>
                                    <base-checkbox class="mt-2" v-model="filter.exportStatus.pending">Pending</base-checkbox>
                                    <base-checkbox class="mt-2" v-model="filter.exportStatus.saved">Saved</base-checkbox>
                                  </div>
                                  <div class="col-12 mt-4 mb-2 px-4">
                                    <button class="btn btn-sm py-2 btn-block btn-primary" @click="getPromotions">Apply filters</button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="col">
                            <input type="text" class="form-control" v-model="filter.search" :placeholder="`Search promotions by ${filter.searchField}`" @keyup.enter="getPromotions">
                          </div>
                          <div class="col" style="min-width: 50px; max-width: 50px">
                            <div class="form-control cursor-pointer text-center px-0" style="width: 45px" @click="getPromotions">
                              <i class="fas fa-search"></i>
                            </div>
                          </div>
                        </div>
                        <div class="form-row mt-2">
                          <div class="col" @click="toggleAll">
                            <base-checkbox class="my-2" :checked="promotions.filter(r => r.selection).length === promotions.length && promotions.length > 0">
                              <span v-if="promotions.filter(r => r.selection).length > 0">
                                Selected {{promotions.filter(r => r.selection).length}} promotions
                              </span>
                              <span v-else>Showing {{promotions.length}} promotions</span>
                            </base-checkbox>
                          </div>
                          <div class="col-5" v-if="promotions.filter(r => r.selection).length > 0">
                            <div class="btn-group float-right">
                              <div class="cursor-pointer p-2 px-3" @click="promotionAction('sync')" title="Sync now">
                                <i class="fas fa-sync-alt text-primary"></i>
                              </div>
                              <div class="cursor-pointer p-2 px-3" @click="promotionAction('activate')" title="Activate">
                                <i class="fas fa-power-off text-success"></i>
                              </div>
                              <div class="cursor-pointer p-2 px-3" @click="promotionAction('deactivate')" title="Deactivate">
                                <i class="fas fa-power-off text-warning"></i>
                              </div>
                            </div>
                          </div>
                        </div>
                        <hr class="mt-3 mb-0">
                        <br v-if="loading">
                        <a-spin :spinning="loading" class="mt-2">
                          <promotions-table :promotions="promotions" :current_page="current_page" :total_pages="total_pages" :display_pagination="display_pagination" :promoTab="promoTab" @getPromotions="getPromotions" @openPromotion="openPromotion"></promotions-table>
                        </a-spin>
                    </div>
                </div>
            </div>
        </div>
        <a-drawer :width="`100%`" placement="right" @close="onClose" :visible="visible">
          <div>
            <promotion-form @closeDrawer="closeDrawer" :mode="formMode" :promotionId="promotionId" :viewMode="false" v-on:refreshPage="refreshPage"></promotion-form>
          </div>
        </a-drawer>
    </div>
</template>

<script>
  import { mapState } from 'vuex'
  import HTTPRequest from '../../controllers/httpRequest.js'
  import PromotionsTable from './SalesChannelPromotionsTable'
  import PromotionForm from './SalesChannelPromotionForm'

  const sleep = function(ms) {
    return new Promise((resolve) => {
      setTimeout(resolve, ms);
    });
  }

  export default {
    components: {
        PromotionsTable,
        PromotionForm
    },
    computed: {
       ...mapState(['endPoint']),
       formMode: function(){
         return this.promotionId ? `update` : `create`
       }
    },
    data() {
      return {
        promoTab: 'all',
        promotionId: null,
        dropdowns: {
          filter: false
        },
        filter:{
          search: '',
          searchField: 'name',
          promoStatus: {
            active: true,
            inactive: true
          },
          exportStatus: {
            posted: true,
            pending: true,
            saved: true
          },
          sortBy: 'updated_at',
          sortOrder: 'desc'
        },
        selections: {
          all: false
        },
        onlineStorePromos:  0,
        shopifyPromos:  0,
        lazadaPromos:  0,
        shopeePromos:  0,
        promotions: [],
        visible: false,
        windowWidth: 0,
        loading: true,
        current_page: 1,
        total_pages: 1,
        display_pagination: false
      }
    },
    methods: {
      getWindowWidth() {
        this.windowWidth = window.innerWidth
      },
      onClose: function() {
        this.promotionId = null
        this.visible = false
      },
      closeDrawer: function(){
        this.onClose()
      },
      showDrawer: function() {
        this.visible = true
      },
      openPromotion: function(evt, id){
        this.promotionId = null
        if(id){
          this.promotionId = id
          this.showDrawer()
        }
      },
      toggleDropdown: function(field){
        this.dropdowns[field] = !this.dropdowns[field]
      },
      getPromotions: async function(evt, page){
        if(page)
          this.current_page = page
        this.total_pages = 0
        this.promotions = []
        this.loading = true
        this.display_pagination = false

        let query = `page=${this.current_page}&tab=${this.promoTab}&searchField=${this.filter.searchField}&sortBy=${this.filter.sortBy}&sortOrder=${this.filter.sortOrder}&promoStatus=`
        Object.keys(this.filter.promoStatus).forEach(key => {
          if(this.filter.promoStatus[key])
            query += `${key},`
        });
        query += `&exportStatus=`
        Object.keys(this.filter.exportStatus).forEach(key => {
          if(this.filter.exportStatus[key])
            query += `${key},`
        });
        if(this.filter.search.trim() !== '')
          query += `&search=${this.filter.search}`

        const response = await HTTPRequest.getRequest(this.endPoint + `sales_channel_promotions?${query}`, null)
        this.onlineStorePromos = response.totals && response.totals.online_store || 0
        this.shopifyPromos = response.totals && response.totals.shopify || 0
        this.lazadaPromos = response.totals && response.totals.lazada || 0
        this.shopeePromos = response.totals && response.totals.shopee  || 0
        this.promotions = response.data || []
        this.total_pages = response.total_pages || 1
        this.display_pagination = this.total_pages > 1 && this.promotions.length > 0
        this.loading = false;
      },
      toggleTab: function(tab){
        this.promoTab = tab
        this.current_page = 1
        this.getPromotions()
      },
      toggleAll: function(elem){
        if(elem.target.localName === 'input'){
          let selection = elem.target.checked
          this.promotions = this.promotions.map(promotion => {
            return {
              ...promotion,
              selection: selection
            }
          })
        }
      },
      refreshPage() {
        this.getPromotions()
        this.onClose()
      },
      fetchPromotions: async function(initial){
        this.openNotificationWithIcon('info', null, 'Promotions syncing started')
        await HTTPRequest.postRequest(this.endPoint + 'sales_channel_promotions/fetch_promotions', null, {initial_sync: initial})
        this.getPromotions()
      },
      promotionAction: async function(action){
        this.openNotificationWithIcon('info', null, 'Promotion syncing started')
        let selectedPromotions = this.promotions.filter(r => r.selection)
        let request = {}
        let responses = []
        let response
        switch (action) {
          case 'sync':
            request = { id: null }
            break;
          case 'activate':
            request = { id: null, promo_status: 'active' }
            break;
          case 'deactivate':
            request = { id: null, promo_status: 'inactive' }
            break;
        }
        if(Object.keys(request).length > 0)
          for await (let promotion of selectedPromotions){
            request.id = promotion.id
            response = await HTTPRequest.postRequest(this.endPoint + 'sales_channel_promotions/sync_promotion', null, request)
            if(response && typeof(response) === "object")
              response.forEach(res => responses.push(res));
            else
              responses.push({
                error: 'An error occured while syncing. Please try again.'
              })
          }

        responses.forEach(res => {
          this.openNotificationWithIcon(res.error ? 'error' : 'success', res.error || res.message, 'Promotion syncing')
          sleep(500)
        })
        this.promotions.forEach(r => r.selection = false);
        this.getPromotions()
      },
      openNotificationWithIcon(type, description, title) {
        this.$notification[type]({
          message: title || 'Error',
          description: description
        });
      }
    },
    mounted: function(){
      this.getPromotions()
      this.getWindowWidth()
    }
  }
</script>
